<template lang="pug">
.card.market-card
  .card-header.bg-more-head.collapse-more(
    :id="'heading-ousl-' + childId"
    data-toggle='collapse'
    :data-target="'#collapse-ousl-' + childId"
    :aria-controls="'collapse-ousl-' + childId"
    aria-expanded=true
  )
    .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ leagueName.trim() }}
  .collapse.show(
    :aria-labelledby="'heading-ousl-' + childId"
    :id="'collapse-ousl-' + childId"
  )
    .card-body.p-0
      .market-card-content
        .two-column
          //- .two-column-title {{ source }}
          .two-column-content
            .two-column-group
              .two-column-odd-area
                .two-column-odd-area-oddtype
                  p.mb-0 {{ $t("m.ODD_Home") }}
                .two-column-odd-area-group
                  template(v-if="source['ou'] && source['ou'][0] && source['ou'][0][11] != 0 && source['ou'][0][12] != 0 && source['ou'][0][11] != '' && source['ou'][0][12] != ''")
                    OddsItem(:odds="source['ou'][0]" idx=12 :typ="oddsType" dataType="1" mode="ou" label="over" count="0" :details="source" homeAway="1")
                  template(v-else)
                    OddsDisabled
            .two-column-group
              .two-column-odd-area
                .two-column-odd-area-oddtype
                  p.mb-0 {{ $t("m.ODD_Away") }}
                .two-column-odd-area-group
                  template(v-if="source['ou'] && source['ou'][0] && source['ou'][0][11] != 0 && source['ou'][0][12] != 0 && source['ou'][0][11] != '' && source['ou'][0][12] != ''")
                    OddsItem(:odds="source['ou'][0]" idx=11 :typ="oddsType" dataType="1" mode="ou" label="under" count="0" :details="source" homeAway="2")
                  template(v-else)
                    OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    childId: {
      type: Number
    },
    mode: {
      type: Number
    }
  },
  computed: {
    leagueName() {
      var result = this.source["league"].split(" - ");
      if (result.length >= 2) {
        return result[result.length - 1];
      }
      return this.source["league"];
    }
  }
}
</script>